import { useState, useContext } from "react"
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Typography,
  Divider,
  IconButton
} from "@mui/material";
import "../../../Style/dialogstyle.scss"
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import {SelectProvincailCouncilInMandate} from "../../Include/DynamicSelect";
import { AuthContext } from "../../../Context/AuthContext";
import ProvincailCouncilItem from "./ProvincailCouncilItem"



export default function ProvincailCouncilList ({
        newProvincailCouncil, 
        provincailCouncilList, 
        setProvincailCouncilList, 
        viewOnly
    }){
  
    // Change Language
    const { t, setAlert } = useContext(AuthContext);

    // Function to add a new item to the list
    const handleAddItem = () => {
        setProvincailCouncilList((prev) => [...prev, newProvincailCouncil]);
    };

    return (

        <Grid container>
            <Grid item xs={12}>
            <Stack direction={"row"} justifyContent={'space-between'}>
                <Stack 
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography className={t("class-name-field-title")}>
                        {t("thead_provincail_council")}
                    </Typography>
                </Stack>
                <IconButton onClick={handleAddItem} disabled={viewOnly}>
                    <AddBoxIcon 
                        fontSize="medium"
                        sx={{ color: viewOnly ? "gray" : "green", cursor: "pointer" }} 
                    />
                </IconButton>
            </Stack>
            </Grid>
            <Grid item xs={12}>
            <Divider />
            </Grid>
            <Grid item xs={12}>
                <Stack direction={"column"} spacing={0.5}>
                    {
                        provincailCouncilList?.map((elem, index) => (
                            <ProvincailCouncilItem 
                                elem={elem}
                                index={index}
                                setProvincailCouncilList={setProvincailCouncilList}
                                viewOnly={viewOnly}
                            />  
                        ))
                    }
                </Stack>
            </Grid>
        </Grid>
      
    )
}